import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

const eventSeatingOptionsFragment = gql`
  fragment eventSeatingOptions on SeatingOptions {
    entrance
    section
    row
    seat
  }
`

export const eventSeatingOptionsFragmentPropTypes = PropTypes.shape({
  entrance: PropTypes.bool.isRequired,
  section: PropTypes.bool.isRequired,
  row: PropTypes.bool.isRequired,
  seat: PropTypes.bool.isRequired,
})

export default eventSeatingOptionsFragment
